import { CSSProperties } from "react";
import { DateTime } from "luxon";
import { SchoolClosure } from "model";
import { Colors, DateInput } from "swing-components";

import { isSameDate } from "~components/RequestForm/hooks";

type ClosuresListItemProps = {
  closure: SchoolClosure;
};

const styles = {
  listItem: {
    padding: 16,
    paddingLeft: 0,
    borderBottom: `1px solid ${Colors.slate200}`,
  },
  dates: {
    margin: 0,
    marginBottom: 12,
    fontWeight: 500,
  },
} satisfies Record<string, CSSProperties>;

export function ClosuresListItem(props: ClosuresListItemProps) {
  const {
    closure: { id, start, end, reason },
  } = props;

  if (!start || !end) return;

  const startDateTime = DateTime.fromISO(start);
  const endDateTime = DateTime.fromISO(end);
  const isSingleDay = isSameDate(startDateTime, endDateTime);

  return (
    <li key={id} css={styles.listItem}>
      <p css={styles.dates}>
        <DateInput value={startDateTime.toISODate()} isReadOnly />
        {!isSingleDay && (
          <>
            {" - "}
            <DateInput value={endDateTime.toISODate()} isReadOnly />
          </>
        )}
      </p>
      <p css={{ margin: 0 }}>{reason}</p>
    </li>
  );
}
